import { LogoHeader } from '@/components/molecules/header/LogoHeader';
import { useI18nContext } from '@/core/providers/I18nProvider';
import React from 'react';
import { StyleSheet, View } from 'react-native';

/** BaseHeader trailing inset: container padding 16 + right section padding 16. */
const HEADER_TRAILING_INSET = 32;

export interface BloomUniversalLanguageHeaderProps {
  readonly showBackButton?: boolean;
  /** Match the page content inset from the trailing edge. */
  readonly sideInset?: number;
}

/**
 * Welcome-style language toggle for Bloom Universal (web guest).
 * Fixed overlay — dark language label on the white hub.
 * Hub home must pass `showBackButton={false}` — never show back on `/universal`.
 */
export function BloomUniversalLanguageHeader({
  showBackButton = false,
  sideInset = 0,
}: Readonly<BloomUniversalLanguageHeaderProps>) {
  const { isRTL } = useI18nContext();
  const trailingInset = Math.max(0, sideInset - HEADER_TRAILING_INSET);

  return (
    <View
      style={[
        styles.wrap,
        isRTL ? { paddingLeft: trailingInset } : { paddingRight: trailingInset },
      ]}
      pointerEvents="box-none"
    >
      <LogoHeader
        showLanguageSwitch
        hideLogo
        showBackButton={showBackButton}
        backButtonColor="white"
        languageTextColor="fontPrimary"
      />
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 3,
  },
});

export default BloomUniversalLanguageHeader;
